@if (isVisible()) {
<button
  [attr.aria-label]="(open() ? 'Close' : 'Open') + ' menu' | translate"
  [@slideFromLeft]="true"
  class="trigger"
  avButton
  color="link"
  ofType="icon"
  size="sm"
  [disabled]="isToggleDisabled()"
  (click)="toggle($event)"
>
  @if (open()) {
  <av-icon [mode]="toggleColorMode()" name="close-big"></av-icon>
  } @if (!open()) {
  <av-icon name="menu"></av-icon>
  }
</button>
} @if (isVisible()) {
<av-card
  (click)="cancel($event)"
  class="user-menu-card"
  [class.open]="open()"
  [attr.inert]="!open() || null"
>
  <av-card-body
    type="container"
    class="fx-column fx-align-stretch fx-justify-space-between"
  >
    <av-menu class="user-menu" #menu>
      <av-menu-item
        [attr.aria-label]="'Go home' | translate"
        [active]="active('welcome')"
        icon="home"
        (select)="go('welcome')"
      >
        {{ "Home" | translate }}
      </av-menu-item>
      @if (isScheduleEnabled()) {
      <av-menu-item
        [attr.aria-label]="'Go to appointments' | translate"
        [active]="active('schedule')"
        icon="calendar-time-thin"
        (select)="go('schedule')"
      >
        {{ "Appointments" | translate }}
      </av-menu-item>
      } @if (isInteractionsEnabled()) {
      <av-menu-item
        [attr.aria-label]="'Go to interactions' | translate"
        [active]="active('interaction')"
        icon="archive"
        (select)="go('interaction')"
      >
        {{ "Interactions" | translate }}
      </av-menu-item>
      } @if (isActivityEnabled()) {
      <av-menu-item
        [aria-label]="'Go to activity' | translate"
        [active]="active('activity')"
        icon="binoculars"
        (select)="go('activity')"
      >
        {{ "Activity" | translate }}
      </av-menu-item>
      } @if (isMetricsEnabled()) {
      <av-menu-item
        [active]="active('reports')"
        icon="bar-chart"
        (select)="go('reports')"
        [attr.aria-label]="'Go to reports' | translate"
      >
        {{ "Reports" | translate }}
      </av-menu-item>
      } @if (isRecordingEnabled()) {
      <av-menu-item
        [active]="active('exports')"
        icon="record"
        (select)="go('exports')"
        [attr.aria-label]="'Go to exported recordings' | translate"
      >
        {{ "My exports" | translate }}
      </av-menu-item>
      } @if (isAuditEnabled()) {
      <av-menu-item
        [active]="active('audit')"
        icon="notepad"
        (select)="go('audit')"
        [attr.aria-label]="'Go to audit logs' | translate"
      >
        {{ "Audit" | translate }}
      </av-menu-item>
      } @if (isConfigEnabled()) {
      <av-menu-item
        [active]="active('settings')"
        icon="settings"
        (select)="go('settings')"
        [attr.aria-label]="'Go to settings' | translate"
      >
        {{ "Settings" | translate }}
      </av-menu-item>
      } @if (isHelpOn()) {
      <av-menu-item
        [attr.aria-label]="'Go to help center' | translate"
        icon="help"
        (select)="help()"
      >
        {{ "Help Center" | translate }}
      </av-menu-item>
      }
    </av-menu>
    <div>
      <av-menu-item type="separator"></av-menu-item>
      <div class="user fx-row fx-align-center">
        <div class="user-avatar">
          @if (!avatarError()) {
          <img
            aria-hidden="true"
            (error)="avatarError.set(true)"
            [src]="avatar()"
          />
          } @if (avatarError()) {
          <av-icon mode="light" name="user"></av-icon>
          }
        </div>
        <div class="fx-column">
          @if (displayName()) {
          <b>{{ displayName() }}</b>
          }
          <div
            class="fx-row fx-wrap fx-align-center"
            (click)="toggleId($event)"
          >
            @if (roles()) { @for (r of roles(); track r; let i = $index) {
            <small
              [attr.aria-label]="('User role ' | translate) + r"
              class="text-muted"
            >
              <span role="presentation" translate>{{ r }}</span
              >@if (i < roles().length - 1) {
              <span role="presentation">,&nbsp;</span>
              }
            </small>
            } }
          </div>
        </div>
      </div>
      @if (idOn()) {
      <small class="text-muted user-id">{{ id() }}</small>
      }
    </div>
  </av-card-body>
</av-card>
}
